import {RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle, Router} from '@angular/router';
import { AccountGridComponent } from './views/account-grid/account-grid.component';
import {AppDevAccountSheetComponent} from './views/app-dev-account-sheet/app-dev-account-sheet.component';

export class AppRouteReuseStrategy implements RouteReuseStrategy {

    private storedRoutes = new Map<string, DetachedRouteHandle>();

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const path = route.routeConfig?.path;
        const routeKey = this.toRouteKey(route);
        return routeKey != null;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const routeKey = this.toRouteKey(route);
        if (!routeKey) {
            return;
        } else {
            console.debug('-+-+-+-+-+-+-+-+Storing route with key:', routeKey);
            this.storedRoutes.set(routeKey, handle);
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const routeKey = this.toRouteKey(route);
        if (routeKey) {
            return !!this.storedRoutes.get(routeKey);
        } else {
            return false;
        }
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle  | null {
        const routeKey = this.toRouteKey(route);
        if (!routeKey) {
            return null;
        } else {
            return this.storedRoutes.get(routeKey)!;
        }
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    async discardRoutesForSegment(segmentId: string): Promise<void> {
        console.debug('Discarding all routes by (id)-pattern for segment:', segmentId);
        for (const entry of this.storedRoutes.entries()) {
            const key = entry[0];
            if (key.indexOf(segmentId) >= 0) {
                this.storedRoutes.delete(key);
                // try to handle the ngOnDestroy lifecycle hook if it exists
                const component = (entry[1] as any)?.componentRef?.instance;
                if (typeof component?.ngOnDestroy === 'function') {
                    try {
                        const retval = component.ngOnDestroy();
                        if (retval instanceof Promise) await retval;
                    } catch (e) {
                        console.error('Error during ngOnDestroy:', e);
                    }
                }
            }
        }
    }

    /**
     * Converts an ActivatedRouteSnapshot to a route key. When a non-null key is returned,
     * the route will be stored and reused.
     * @param route The ActivatedRouteSnapshot to convert.
     */
    private toRouteKey(route: ActivatedRouteSnapshot): string | undefined {
        if (route.component === AccountGridComponent || route.component === AppDevAccountSheetComponent) {
            const segmentId = route.params['segmentId'];
            if (segmentId) return `${route.component.name}-${segmentId}`;
        }
        return undefined;
    }
}
